import { CLASS_NAMES } from "../../utils/constants"
import BaseObject from "./BaseObject"

export default class GameObject extends BaseObject {
  constructor({ id, isRigid, isBreakable, isFlat, isPickable, isCrushable, level }) {
    super()
    this.id = id
    // can't be moved nor affected by gravity
    // wall, ground
    this.isRigid = isRigid

    // destroyable under circumstances like explosions
    // ground, boulder, diamond
    this.isBreakable = isBreakable

    // rounded objects (like boulders and diamonds) above remain still
    // character, ground, wall
    this.isFlat = isFlat

    // can be collected by characters
    // diamond
    this.isPickable = isPickable

    // crush under pression
    // character, enemies, dynamite, barrel
    this.isCrushable = isCrushable

    // energy to break things
    this.power = 0

    // how resistant to brake it is
    this.strength = 0

    // how hard can push
    this.force = 0

    // how much force can resist before move
    this.weight = 0

    this.level = level

    this.position = null
    this.alien = null
    this.isMoveable = !this.isRigid
  }

  setPosition(coords) {
    this.position = coords
  }

  canMove() {
    return this.isMoveable
  }
  overrunBy(){}
  runningOver(){}
  canFallDown() { return false }
  canFallLeft() { return false }
  canFallRight() { return false }
  addedToScene() {}
  hitBy() {}
  
}

GameObject.className = CLASS_NAMES.GAME_OBJECT
